<template>
  <v-container grid-list-xl text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 sm10 offset-sm1>
        <v-card>
          <v-form ref="eventForm">
            <v-toolbar card color="primary">
              <v-toolbar-title class="headline font-weight-regular primary white--text" primary-title>
                {{ routedLocation ? routedLocation.title : (location.title.length > 2) ? location.title : 'Location' }} - Details
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn v-if="currentUserIsOwner" color="pink" fab right fixed dark small @click="editMode = !editMode">
                <v-icon dark v-if="editMode">close</v-icon>
                <v-icon dark v-else>edit</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-form>

                <v-layout row wrap>
                  
                  <!-- Place Title -->
                  <v-flex xs10 offset-xs1>
                    <v-text-field 
                      v-model="location.title" 
                      label="Name" 
                      :disabled="routedLocation ? !editMode : false"
                      hint="What's the name of your location?"
                      persistent-hint
                      clearable></v-text-field>
                  </v-flex>

                  <!-- Place Location -->
                  <v-flex xs10 offset-xs1>
                    <Autocomplete 
                      id="location-name" 
                      :defaultdata="routedLocation ? routedLocation.address : ''"
                      :disabled="routedLocation ? !editMode : false"
                      v-on:placechanged="setLocation"
                       required></Autocomplete>
                  </v-flex>

                  <v-flex xs10 offset-xs1>
                    <v-btn-toggle v-model="location.type">
                      <v-btn :disabled="routedLocation ? !editMode : false" flat value="home">
                        <span>Home</span>
                        <v-icon>home</v-icon>
                      </v-btn>
                      <v-btn :disabled="routedLocation ? !editMode : false" flat value="work">
                        <span>Work</span>
                        <v-icon>work_outline</v-icon>
                      </v-btn>
                      <v-btn :disabled="routedLocation ? !editMode : false" flat value="other">
                        <span>Other</span>
                        <v-icon>pin_drop</v-icon>
                      </v-btn>
                    </v-btn-toggle>
                  </v-flex>

                  <!-- Combobox -->
                  <!-- <v-flex xs10 offset-xs1>
                    <v-combobox :disabled="routedLocation ? !editMode : false" v-model="routedLocation ? routedLocation.event : location.event" :items="allEventItems" return-object item-text="name" item-value="id" chips label="Connect an event">
                      <template slot="selection" slot-scope="data">
                        <v-chip
                          :key="JSON.stringify(data.item)"
                          class="v-chip--select-multi "
                          @input="data.parent.selectItem(data.item)"
                        >
                          <v-avatar class="accent white--text">
                            {{ data.item['name'].substring(0,1) ? data.item['name'].substring(0,1) : '' }}
                          </v-avatar>
                          {{ data.item['name'] ? data.item['name'] : ''}}
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-flex>  -->

                </v-layout>

              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <template v-if="editMode">
                <v-btn color="error" @click="deleteDialog = true">Delete</v-btn>
              </template>
                <v-btn flat color="primary" @click="$router.go(-1)">Cancel</v-btn>
                <v-btn v-if="currentRouteId != 'new'" color="primary" @click="saveLocation()">Save</v-btn>
                <v-btn v-if="currentRouteId == 'new'" color="primary" @click="addLocation()">Save</v-btn>
            </v-card-actions>
          </v-form>

          <!-- Snackbar - Alert -->
          <v-snackbar
            v-model="snackbar.show"
            :color="snackbar.color"
            multi-line="multi-line"
            :timeout="snackbar.timeout"
          >
            {{ snackbar.text }}
            <v-btn dark flat @click="snackbar.show = false">
              Close
            </v-btn>
          </v-snackbar>

          <v-dialog v-model="deleteDialog" persistent max-width="290">
            <v-card>
              <v-card-title class="headline font-weight-regular error white--text">Delete Location?</v-card-title>
              <v-card-text>By deleting this location you understand that... the location will be deleted. If you would like to delete the location, please click delete</v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click.native="deleteDialog = false">Cancel</v-btn>
                <v-btn color="error" @click.native="deleteLocation()">Delete</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Autocomplete from '../components/Autocomplete'

  import { eventBus } from '../main'
  import { mapState } from 'vuex'
  import uuidv4 from 'uuid/v4'

  export default {
    name: 'location', 
    components: { Autocomplete },
    data(){
      return {
        location: {
          id: null,
          title: '', 
          address: '',
          latLng: null, 
          type: 'other', 
          event: null,
        },  
        selectedLocations: null,
        editMode: false,
        deleteDialog: false,
        snackbar: {
          color: 'success', 
          text: ''
        },
      }
    }, 
    methods: {
      setLocation(formattedPlace, rawPlace){
        this.location.address = rawPlace.formatted_address;
        this.location.latLng = rawPlace.geometry.location;
      },
      deleteLocation() {
        this.$store.dispatch('locations/deleteLocationById', this.$route.params.id);
        this.deleteDialog = false;
        this.$router.push('/');
      },
      addLocation(){
        this.location.id = uuidv4()
        this.$store.dispatch('locations/addLocation', this.location);

        this.snackbar.text = 'Location successfully added!';
        this.snackbar.color = 'success'; 
        eventBus.$emit('snackAlert', this.snackbar);

        setTimeout(() => {
          this.$router.push({path: `/location/${this.location.id}`})
        }, 3000);
      },
      saveLocation(){
        this.$store.dispatch('locations/updateLocation', this.location);

        this.snackbar.text = 'Location successfully saved!';
        this.snackbar.color = 'success';
        eventBus.$emit('snackAlert', this.snackbar);

        this.editMode = false;

        setTimeout(() => {
          this.$router.push({path: `/location/${this.location.id}`})
        }, 3000);
      }
    },
    created() {
      if(this.$route.params.id){
        this.$store.dispatch('locations/getLocationById', this.$route.params.id);
      }
    }, 
    watch: {
      routedLocation(newLocation, oldLocation){
        if(typeof newLocation == 'object'){
          this.location = this.routedLocation;
        }
      }
    },
    computed: {
      ...mapState({
        currentUser: state => state.users.currentUser, 
        allEvents: state => state.events.allEvents, 
        sharedEvents: state => state.events.sharedEvents,
        routedLocation: state => state.locations.routedLocation
      }),
      currentRouteId(){
        if(this.$route.params.id){
          return this.$route.params.id
        } else { 
          return false
        }
      },
      // Added 8/22
      allEventItems(){
        return this.allEvents.concat(this.sharedEvents);
      },
      currentUserIsOwner(){
        return this.routedLocation !== undefined ? this.routedLocation.owner == this.currentUser ? true : false : false
      }
    }, 
    beforeRouteUpdate(to, from, next){
      // console.log(JSON.stringify(to))
      // console.log(`From: ${JSON.stringify(from)}`)
      // console.log(to.params)

      if(to.params.id != 'new'){
        // console.log('In if')
        // console.log(`Location id: ${to.params.id}`)
        this.$store.dispatch('locations/getLocationById', to.params.id);

        this.location = this.routedLocation
        next()
      } else if(to.params.id == 'new') {

        this.$store.dispatch('locations/clearCurrentLocation');
        this.location.event = null;
        this.location = {
          id: uuidv4(),
          title: '', 
          address: '',
          latLng: null, 
          type: 'other', 
          event: null,
        }
        next()
      }

    },
  }
</script>
<style>
</style>